import { motion } from "framer-motion";
import { SERVICES } from "@/data/site";
import { useLang } from "@/i18n/LangContext";

const Card = ({ s, i, feature }) => {
  const Icon = s.icon;
  const { pick } = useLang();
  return (
    <motion.article
      initial={{ opacity: 0, y: 70, rotate: i % 2 ? 3 : -3, clipPath: "inset(48% 0% 48% 0% round 24px)" }}
      whileInView={{ opacity: 1, y: 0, rotate: 0, clipPath: "inset(0% 0% 0% 0% round 24px)" }}
      viewport={{ once: false, amount: 0.01 }}
      transition={{ duration: 0.7, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -8 }}
      className={`group relative overflow-hidden rounded-3xl border border-[#00C9B7]/15 bg-[#131B21] ${feature ? "md:col-span-2 min-h-[340px]" : "min-h-[340px]"}`}
      data-testid={`service-card-${i}`}
    >
      <img src={s.img} alt={s.title} className={`absolute inset-0 w-full h-full object-cover ${s.pos || ""} opacity-50 group-hover:opacity-75 group-hover:scale-110 transition-[opacity,transform] duration-700`} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F12] via-[#0B0F12]/70 to-transparent" />
      <div className="relative h-full p-7 sm:p-8 flex flex-col justify-end">
        <div className="w-12 h-12 rounded-2xl bg-[#00C9B7]/15 border border-[#00C9B7]/30 flex items-center justify-center text-[#00C9B7] mb-auto group-hover:bg-[#00C9B7] group-hover:text-[#031312] transition-colors"><Icon size={22} /></div>
        <h3 className="font-display uppercase text-2xl text-white mt-16 mb-3">{pick(s, "title")}</h3>
        <p className="text-sm text-slate-300 leading-relaxed">{pick(s, "desc")}</p>
      </div>
    </motion.article>
  );
};

export default function ServicesGrid() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-testid="services-grid">
      {SERVICES.map((s, i) => <Card key={s.title} s={s} i={i} feature={i === 0 || i === 7} />)}
    </div>
  );
}
